import { RouterMenuName } from "@/enum/RouterMenuName";
import { menu } from "@/router/menu";
import { HeaderClassType } from "@/enum/HeaderClassType";
import { LayoutType } from "@/enum/LayoutType";
import { RouteConfig } from "vue-router";
import RouterMeta from "@/router/model/RouterMeta";

const meta: RouterMeta = {
  headerClass: `${HeaderClassType.My}`,
  layout: LayoutType.NavigationLayout
};

const organization: RouteConfig[] = [
  {
    path: "/organization",
    component: menu.organization.main,
    name: RouterMenuName.Organization,
    meta: meta
  },
  {
    path: "/organization/inquiry",
    component: menu.organization.inquiry,
    name: RouterMenuName.OrganizationInquiry,
    meta: meta
  }
];

export const organizationPage: RouteConfig[] = organization;
